import { type OrderClaimCreateDto, postClaims } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { invalidateClaimsForOrder } from "Order/Api/invalidateOrderQueries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.claim.claimsMutations;

export const useCreateClaim = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((data: OrderClaimCreateDto) =>
			postClaims(data),
		),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.claimCreateError)}:`, error);
		},
		onSuccess: async () => {
			await invalidateClaimsForOrder(queryClient, orderId);
			toast.success(t(orderMutationsResource.claimCreateSuccess));
		},
	});
};
